export const IGNORE_ROUTES = [
  'objects_edit',
  'admin-categories',
  'admin-categories-id',
  'admin-icons',
  'admin-icons-id',
  'admin-objects',
  'admin-donats',
  'admin-donats-id',
  'admin-property_templates',
  'admin-property_templates-id',
  'admin-types',
  'admin-types-id',
  'admin-users',
  'admin-users-id',
  'ms',
  'ms-scan_social',
  'ms-scan_social-source',
  'ms-scan_social-source-id',
  'ms-scan_social-messages',
  'ms-scan_social-messages-id',
  'ms-assistant_ai',
  'ms-assistant_ai-projects',
  'ms-assistant_ai-projects-id',
  'ms-assistant_ai-dialogue',
  'ms-assistant_ai-dialogue-id',
  'ms-assistant_ai-dialogue_list',
  'ms-assistant_ai-dialogue_list-id',
  'login',
  'admin',
  'icons-list',
  'login',
  'objects-create',
  'my',
  'available',
  'mystat',
  'admin-art',
  'my-art',
  'art-create',
  'art_edit',
  'profile',
]
